import { Vector } from "./Vector";
import { Conic } from "./Conic";
import { Time } from "./Time";
import * as Constants from "./Constants";
import { TrajectorySegment } from "./TrajectorySegment";
import { Chebyshev } from "./Chebyshev";

export class ChebyshevTrajectorySegment extends TrajectorySegment {
    order: number;
    coeffs: number[];

    constructor(data: any) {
        super(data);
        this.order = data.order;
        this.coeffs = data.coeffs;
    }

    getPos(time: number): Vector {

        if (time < this.startTime || time > this.endTime)
            throw new RangeError("Time outside valid range");

        // get index of polynomial applicable to the given time
        let index = Math.floor((time - this.startTime) / this.timeStep);

        let coeffs = [];
        let stride = 3 * (this.order + 1);
        for (let i = index * stride; i < (index + 1) * stride; i++) {
            coeffs.push(this.coeffs[i]);
        }

        var cheby = new Chebyshev({
            order: this.order,
            components: 3,
            startTime: Time.ticksToMjd(this.startTime + index * this.timeStep),
            endTime: Time.ticksToMjd(this.startTime + (index + 1) * this.timeStep),
            coeffs: coeffs
        });

        var pos = cheby.evaluate(Time.ticksToMjd(time));

        return new Vector(pos[0], pos[1], pos[2]);
    }
}


// WEBPACK FOOTER //
// ./src/ChebyshevTrajectorySegment.ts